import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FolderIcon from '@mui/icons-material/Folder';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import SubjectIcon from '@mui/icons-material/Subject';
import LinkIcon from '@mui/icons-material/Link';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import TimerIcon from '@mui/icons-material/Timer';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { CalendarMonth } from '@mui/icons-material';
import { ServiceModuleType, ServiceModuleTypes } from '../../types/serviceModuleTypes';
import { useAppDispatch } from '../../hooks/StoreHooks';
import { createServiceModuleThunk } from '../../store/thunk/serviceModulesThunk';
import { QuickCreateItem, QuickCreatePanel } from './ServiceModules.styles';

type ServiceModuleCreatorProps = {
    parentFolderId?: number;
    onClose: () => void;
};

const typeToIdMap: Record<string, number> = {
    [ServiceModuleTypes.Calendar]: 1,
    [ServiceModuleTypes.File]: 2,
    [ServiceModuleTypes.Folder]: 3,
    [ServiceModuleTypes.Text]: 4,
    [ServiceModuleTypes.Url]: 5,
    [ServiceModuleTypes.Leaderboard]: 6,
    [ServiceModuleTypes.Timetracking]: 7,
    [ServiceModuleTypes.Absence]: 8,
};

const moduleOptions = [
    {
        type: ServiceModuleTypes.Calendar,
        icon: <CalendarMonth sx={{ marginRight: 1 }} />,
        labelKey: "serviceModulesPage.folderServicePage.addCalendar",
    },
    {
        type: ServiceModuleTypes.Folder,
        icon: <FolderIcon sx={{ marginRight: 1 }} />,
        labelKey: "serviceModulesPage.folderServicePage.addFolder",
    },
    {
        type: ServiceModuleTypes.File,
        icon: <InsertDriveFileIcon sx={{ marginRight: 1 }} />,
        labelKey: "serviceModulesPage.folderServicePage.addFile",
    },
    {
        type: ServiceModuleTypes.Text,
        icon: <SubjectIcon sx={{ marginRight: 1 }} />,
        labelKey: "serviceModulesPage.folderServicePage.addText",
    },
    {
        type: ServiceModuleTypes.Url,
        icon: <LinkIcon sx={{ marginRight: 1 }} />,
        labelKey: "serviceModulesPage.folderServicePage.addUrl",
    },
    {
        type: ServiceModuleTypes.Leaderboard,
        icon: <LeaderboardIcon sx={{ marginRight: 1 }} />,
        labelKey: "serviceModulesPage.folderServicePage.addLeaderboard",
    },
    {
      type: ServiceModuleTypes.Timetracking,
      icon: <TimerIcon sx={{ marginRight: 1 }} />,
      labelKey: "serviceModulesPage.folderServicePage.addTimeTracking",
    },
    {
      type: ServiceModuleTypes.Absence,
      icon: <CalendarMonthIcon sx={{ marginRight: 1 }} />,
      labelKey: "serviceModulesPage.folderServicePage.addAbsence",
    },
];

const ServiceModuleCreator = ({ parentFolderId, onClose }: ServiceModuleCreatorProps) => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch();

    const handleCreate = async (type: ServiceModuleType) => {
        await dispatch(createServiceModuleThunk({
            serviceModuleType: typeToIdMap[type],
            parentFolderServiceModuleId: parentFolderId,
        }));
        onClose();
    };

    return (
        <QuickCreatePanel>
            {moduleOptions.map(({ type, icon, labelKey }) => {
                const baseLabel = t(labelKey);

                return (
                    <Tooltip key={type} title={baseLabel}>
                        <Box>
                            <QuickCreateItem onClick={() => handleCreate(type)}>
                                <IconButton>
                                    {icon}
                                </IconButton>
                                <Typography variant="caption">{baseLabel}</Typography>
                            </QuickCreateItem>
                        </Box>
                    </Tooltip>
                );
            })}
        </QuickCreatePanel>
    );
};

export default ServiceModuleCreator;
